module.exports = __webpack_public_path__ + "static/media/steampunk.0b2a36f6.png";